module.exports = __webpack_public_path__ + "static/img/MV@3x.b81014af.jpg";